<script lang="ts">
    import clsx from 'clsx';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    export let open = false;
    export let choices: string[] = [];
    export let selectedChoices: string[] = [];
    export let value = '';
    export let twoColumn = false;
    export let handleSelect: (event: MouseEvent, option: string) => void;

    let contentClasses: string;

    $: contentClasses = clsx('grid gap-2 px-6 py-4', {
        'grid-cols-2': twoColumn,
    });

    const borderRadius = getBorderRadius('dropdownItem');
</script>

<div class="pointer-events-auto w-full overflow-scroll" on:click|stopPropagation on:keydown>
    {#if !!choices}
        <div class={contentClasses}>
            {#each choices as option}
                <button
                    on:click={(event) => open && handleSelect(event, option)}
                    tabindex={open ? 0 : -1}
                    class={`${borderRadius} focus:border-1 border py-2.5 text-sm font-medium transition focus:border-blue-500 md:text-base`}
                    class:bg-blue-50={selectedChoices.includes(option) || value === option}
                    class:text-blue-500={selectedChoices.includes(option) || value === option}
                    class:border-blue-500={selectedChoices.includes(option) || value === option}
                    class:text-gray-500={!selectedChoices.includes(option) && value !== option}
                    class:border-gray-200={!selectedChoices.includes(option) && value !== option}
                    >{option}</button
                >
            {/each}
        </div>
    {:else}<p class="text-sm">No data</p>{/if}
</div>
